export interface FranchiseFeeLockInvoice {
    status?: string | null;
    created_at?: string | null;
}

const OVERDUE_FEE_LOCK_DAYS = 7;
const OVERDUE_FEE_LOCK_MS = OVERDUE_FEE_LOCK_DAYS * 24 * 60 * 60 * 1000;

export function isOverdueUnpaidFranchiseFee(invoice: FranchiseFeeLockInvoice): boolean {
    if ((invoice.status || '').toLowerCase() === 'paid') {
        return false;
    }

    if (!invoice.created_at) {
        return false;
    }

    const createdAt = new Date(invoice.created_at).getTime();
    if (Number.isNaN(createdAt)) {
        return false;
    }

    return Date.now() - createdAt >= OVERDUE_FEE_LOCK_MS;
}

export function hasOverdueUnpaidFranchiseFee(invoices: FranchiseFeeLockInvoice[]): boolean {
    return invoices.some(isOverdueUnpaidFranchiseFee);
}
